import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";

class VehicleInfo extends Component {
  state = {
    rows: [],
    activeIndex: -1,
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  loadData = (props) => {
    const rows = [];
    if (props.record !== undefined) {
      const { record } = this.props;
      const index = props.detailIndex;
      const color = _.get(record, "primaryColor[0]._", "");
      rows.push(
        <Table.Row key={`veh_inf_row_1_${index}`}>
          <Table.Cell>VIN:</Table.Cell>
          <Table.Cell>{_.get(record, "VIN[0]._", "")}</Table.Cell>
          <Table.Cell>Vehicle Type:</Table.Cell>
          <Table.Cell>{_.get(record, "vehicleType[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`veh_inf_row_2_${index}`}>
          <Table.Cell>Make:</Table.Cell>
          <Table.Cell>{_.get(record, "make[0]._", "")}</Table.Cell>
          <Table.Cell>Body Type:</Table.Cell>
          <Table.Cell>
            {_.get(record, "bodyStyles[0].bodyStyle[0]._", "")}
          </Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`veh_inf_row_3_${index}`}>
          <Table.Cell>Model:</Table.Cell>
          <Table.Cell>{_.get(record, "model[0]._", "")}</Table.Cell>
          <Table.Cell>Series:</Table.Cell>
          <Table.Cell>{_.get(record, "series[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`veh_inf_row_4_${index}`}>
          <Table.Cell>Year:</Table.Cell>
          <Table.Cell>{_.get(record, "modelYear[0]._", "")}</Table.Cell>
          <Table.Cell>State of Origin:</Table.Cell>
          <Table.Cell>
            {_.get(
              record,
              "vehicleRegistrants[0].vehicleRegistrant[0].tags[0].tag[0].licensePlateState[0]._",
              ""
            )}
          </Table.Cell>
        </Table.Row>
      );
      if (color !== "")
        rows.push(
          <Table.Row key={`veh_inf_other_row5_${index}`}>
            <Table.Cell colSpan={2}>&#160;</Table.Cell>
            <Table.Cell>Major Color:</Table.Cell>
            <Table.Cell>{color}</Table.Cell>
          </Table.Row>
        );
    }
    this.setState({ rows });
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    return (
      <Table>
        <Table.Body>
          <Table.Row>
            <Table.HeaderCell
              key={`veh_det_title`}
              colSpan={4}
              className="report-sub-section-header"
            >
              <center>Vehicle Details</center>
            </Table.HeaderCell>
          </Table.Row>
          {this.state.rows}
        </Table.Body>
      </Table>
    );
  }
}

export default VehicleInfo;



// WEBPACK FOOTER //
// ./src/components/reports/Silver/VehicleInfo.js